import { useEffect, useState } from 'react';
import { removeReminder, reminders, type Reminder } from '../reminders';
import { navigate } from '../router';
import { clock, playLink } from './LiveBits';

/** Toont een melding zodra een herinnering afgaat (2 min van tevoren tot 10 min erna). */
export function ReminderToasts() {
  const [due, setDue] = useState<Reminder[]>([]);

  useEffect(() => {
    const check = () => {
      const now = Date.now();
      const list = reminders().filter((r) => r.start - now < 2 * 60_000 && now - r.start < 10 * 60_000);
      setDue((cur) => {
        const fresh = list.filter((r) => !cur.some((c) => c.id === r.id));
        for (const r of fresh) {
          if ('Notification' in window && Notification.permission === 'granted') {
            try {
              new Notification(r.title, { body: `${r.subtitle ? `${r.subtitle} · ` : ''}begint om ${clock(r.start)}`, tag: r.id });
            } catch {
              // sommige browsers staan alleen meldingen via een service worker toe
            }
          }
        }
        return fresh.length ? [...cur, ...fresh] : cur;
      });
      // Verlopen herinneringen opruimen
      for (const r of reminders()) if (now - r.start > 30 * 60_000) removeReminder(r.id);
    };
    check();
    const t = window.setInterval(check, 20_000);
    return () => window.clearInterval(t);
  }, []);

  const close = (r: Reminder) => {
    removeReminder(r.id);
    setDue((d) => d.filter((x) => x.id !== r.id));
  };

  if (!due.length) return null;
  return (
    <div className="toasts" role="region" aria-label="Herinneringen" aria-live="polite">
      {due.map((r) => (
        <div key={r.id} className="toast">
          <span className="subtle">{r.start > Date.now() ? `Begint om ${clock(r.start)}` : 'Is begonnen'}</span>
          <strong>{r.title}</strong>
          {r.subtitle && <span className="muted">{r.subtitle}</span>}
          <div className="form-actions">
            <button className="btn btn-primary btn-sm" onClick={() => { close(r); navigate(playLink(r.accountId, r.streamId)); }}>Kijken</button>
            <button className="btn btn-sm" onClick={() => close(r)}>Sluiten</button>
          </div>
        </div>
      ))}
    </div>
  );
}
